import { GroupStatus, SelectedStatusType } from "@/types/groups";

import { TabItem } from "../tabSelect";

export const GroupStatusOptions: SelectedStatusType[] = [
  { label: "All", value: "" },
  { label: "Active", value: GroupStatus.ACTIVE },
  { label: "Inactive", value: GroupStatus.INACTIVE }
];

export const BADGE_LABEL_STATUS_MAP: { [K: string]: string } = {
  [GroupStatus.ACTIVE]: "Active",
  [GroupStatus.INACTIVE]: "Inactive"
};

export const BADGE_VARIANT_STATUS_MAP: { [K: string]: string } = {
  [GroupStatus.ACTIVE]: "success",
  [GroupStatus.INACTIVE]: "disabled"
};

export const VIEW_GROUP_TAB_OPTIONS: TabItem[] = [
  {
    label: "Module",
    value: "module"
  },
  {
    label: "Assigned Users",
    value: "assignedUsers"
  }
];

export const VIEW_GROUP_TAB_ASSIGNED_USERS_HEADER = [
  {
    title: "Name",
    key: "name"
  },
  {
    title: "Permission",
    key: "permission"
  }
];

// TODO: need to update after API integration
export const MOCK_GROUP_PERMISSION = [
  {
    name: "Data Explorer",
    feature_id: "data-explorer",
    permission: null
  },
  {
    name: "Analysis",
    feature_id: "analysis",
    permission: null
  },
  {
    name: "Data Management",
    feature_id: "data-management",
    permission: null
  }
];

type EditGroupStatusOptionType = {
  label: string;
  value: GroupStatus;
};
export const GROUP_STATUS_OPTIONS: EditGroupStatusOptionType[] = [
  {
    label: "Active",
    value: GroupStatus.ACTIVE
  },
  {
    label: "Inactive",
    value: GroupStatus.INACTIVE
  }
];

export const GROUP_NAME_WITH_GENERAL_OPTIONS = [
  "Data Explorer",
  "Analysis",
  "AI - Dataset Recommendation",
  "AI - Summary Analysis"
];

export const VIEW_GROUP_USER_PERMISSION_GENERAL_MAPPING: Record<
  string,
  string
> = {
  admin: "Yes",
  no: "No"
};

export const VIEW_GROUP_USER_PERMISSION_MODULAR_MAPPING: Record<
  string,
  string
> = {
  admin: "Editor",
  view: "Viewer"
};

export const getViewGroupUserPermissionMapping = ({
  name,
  permission
}: {
  name: string;
  permission: string;
}) =>
  GROUP_NAME_WITH_GENERAL_OPTIONS.includes(name)
    ? VIEW_GROUP_USER_PERMISSION_GENERAL_MAPPING[permission]
    : VIEW_GROUP_USER_PERMISSION_MODULAR_MAPPING[permission];

export const EDIT_GROUP_USER_PERMISSION_GENERAL_OPTIONS = [
  {
    label: "Yes",
    value: "admin"
  },
  {
    label: "No",
    value: "no"
  }
];

export const EDIT_GROUP_USER_PERMISSION_MODULAR_OPTIONS = [
  {
    label: "Editor",
    value: "admin"
  },
  {
    label: "Viewer",
    value: "view"
  }
];

// Get permission options based on the permission name
// If the permission name is in GROUP_NAME_WITH_GENERAL_OPTIONS, return general options
// Otherwise, return modular options
export const getPermissionOptions = (permissionName: string) =>
  GROUP_NAME_WITH_GENERAL_OPTIONS.includes(permissionName)
    ? EDIT_GROUP_USER_PERMISSION_GENERAL_OPTIONS
    : EDIT_GROUP_USER_PERMISSION_MODULAR_OPTIONS;

export const PermissionInfoTooltipContent = () => (
  <ul className="flex flex-col gap-0.5 text-xs">
    <li className="mb-1">
      <strong>Permission Info</strong>
    </li>
    <li>Yes: Full access to all functions</li>
    <li>No: No access to any functions</li>
    <li>Editor: Can view, edit, and delete</li>
    <li>View: Can view only (can't edit)</li>
  </ul>
);

export const GROUP_MANAGEMENT_NO_DATA_MESSAGE_MAPPING = {
  "no-data": {
    title: "No Group Added Yet",
    description: (
      <>
        You haven't added any group. To get started, click{" "}
        <strong>Create Group</strong> and add at least one group.
      </>
    )
  },
  "no-result": {
    title: "No Results Found",
    description:
      "Sorry, we couldn't find any matches from your keyword. Try using different or more general terms"
  }
};

export const GROUP_MANAGEMENT_BREADCRUMB_CONFIG = [
  {
    label: "Settings",
    path: `${import.meta.env.VITE_BASE_PATH}group-management`
  },
  {
    label: "Groups"
  }
];
